import Vue from 'vue'
import './index.less'
import '@/assets/css/global.less'
import Storage from 'vue-ls'
import { Icon, List, Form, Input, Select, Button, DatePicker, Spin, Modal, message } from 'ant-design-vue'
Vue.use(Storage)
Vue.use(Icon)
Vue.use(List)
Vue.use(Form)
Vue.use(Button)
Vue.use(Input)
Vue.use(DatePicker)
Vue.use(Spin)
Vue.use(Modal)
Vue.use(Select)

Vue.prototype.$modal = Modal
Vue.prototype.$message = message
Vue.prototype.$confirm = Modal.confirm
